<template>
  <div
    class="bg-background-neutral-secondary flex flex-col items-center space-y-4 rounded-2xl p-4 text-center"
  >
    <slot name="image"></slot>
    <div v-if="title || message" class="flex flex-col">
      <h4
        v-if="title"
        class="text-text-neutral-primary text-base font-semibold"
      >
        {{ title }}
      </h4>
      <p v-if="message" class="text-text-neutral-quaternary text-sm">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      title?: string;
      message?: string;
    }>(),
    {
      title: '',
      message: '',
    },
  );
</script>
